import { importComponents } from '@hst-horizon/horizon-ui';

const { ProductDetails } = importComponents(async () => {
    return import('./product.module');
}, ['ProductDetails']);

const productDetailsRoutes = [
    {
        path: 'product/:pid/:variantId',
        element: <ProductDetails />,
    },
    {
        path: 'product/:pid',
        element: <ProductDetails />,
    },
];

export default productDetailsRoutes;
